<div class="p-t-m p-b-m p-l-m p-r-m custom-theme-branding branding">
	<button mat-icon-button class="close-button" (click)="onCloseClick()">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
		/>
	</button>

	<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%">
		<div fxLayout="column" fxFlex="100%" fxLayoutAlign="center start">
			<h2>
				<span i18n="@@donorList_donations_title">Donations</span>
				({{ this.donationCount }})
			</h2>
		</div>
	</div>

	<mat-tab-group>
		<mat-tab label="{{ label_donorList_tab1 }}">
			<!--SINGLE DONOR ROW-->
			<div
				fxLayout="column"
				fxLayoutAlign="start start"
				fxLayoutGap.xs="7%"
				fxLayoutGap="0px"
				[style.border-bottom]="'1px solid #ddd'"
				[style.last-child]="'0px'"
				*ngFor="let donor of donorData; let i = index"
			>
				<!--Avatar-->
				<div
					ngClass="m-t-m"
					fxLayout="row"
					fxFill
					fxFlex.xs="20%"
					fxLayoutGap="1%"
					fxLayoutAlign="start center"
				>
					<app-user-icon
						[initialLetters]="getInitial(donor?.name)"
						[index]="i"
					></app-user-icon>

					<div fxLayout="column" fxFlex="20%" fxLayoutAlign="start start">
						<div id="donationName">
							<strong> {{ donor?.name }} </strong>
						</div>
						<div fxLayout="row" fxFlex="100%" fxLayoutAlign="start start">
							<div>
								{{ donor?.message }}
							</div>
						</div>
						<!--REPLY BUTTON-->
						<div>
							<a
								*ngIf="
									(isLoggedInUserAdmin && donor?.reply_message?.length <= 1) ||
									(isLoggedInUserAdmin && !donor?.reply_message)
								"
								i18n="@@button_reply"
								mat-button
								color="accent"
								class="zero-padding-margin"
								(click)="openDialog(i)"
							>
								Reply
							</a>
						</div>
					</div>

					<div
						fxLayout="column"
						fxFlex="100%"
						fxFlex.xs="80%"
						fxLayoutAlign="end end"
					>
						<span class="mat-option">
							{{
								donor?.amount | currency : donor?.symbol : 'symbol' : '1.0-0'
							}}
						</span>
					</div>
				</div>
				<!--Name and Message-->

				<div
					fxLayout="row"
					fxLayout="center center"
					fxFlex="20%"
					fxFlex.xs="80%"
					ngClass.lg="m-t-l"
					[style.marginTop.px]="this.media.isActive('lg') ? '10' : '0'"
					ngClass.lg="m-b-m"
					ngClass.xs="m-t-l"
					ngClass.xs="m-l-l"
					ngClass=""
					ngClass.sm="m-t-l"
				>
					<div
						ngClass.lt-lg="m-l-xl m-t-m m-b-m"
						ngClass.lg="m-l-xl m-t-m m-b-m"
						ngClass.xs="m-b-l"
						ngClass="m-l-xl m-t-xs m-b-xs"
						fxLayout="row"
						fxLayoutAlign="start center"
						*ngIf="
							donor?.reply_message &&
							donor?.reply_message?.length >= 1 &&
							!replyButton
						"
					>
						<img
							*ngIf="donor?.reply_message?.length > 2"
							width="30"
							height="30"
							loading="lazy"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donor_small/public"
						/>
						<div
							*ngIf="donor?.reply_message && donor?.reply_message?.length > 1"
							fxLayoutAlign="start start"
							class="m-l-xs"
							fxFill
						>
							{{ donor?.reply_message }}
							<img
								*ngIf="isLoggedInUserAdmin"
								fxLayoutAlign="center center"
								height="16px"
								class="m-l-xs"
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/editSmall/public"
								(click)="openDialog(i)"
							/>
						</div>
					</div>
				</div>

				<div
					fxFill
					fxLayout="column"
					fxLayoutAlign="start end"
					ngClass="m-b-m"
					*ngIf="
						isLoggedInUserAdmin &&
						i == this.replyIndex &&
						donor?.reply_message?.length <= 1 &&
						showReplyForm &&
						replyButton &&
						donor?.reply_message?.length != undefined
					"
				>
					<div fxLayout="row" fxFill fxLayoutAlign="flex-start">
						<mat-form-field
							class="example-full-width"
							appearance="outline"
							fxFlex="80"
							fxFlexOffset="10"
							fxFlex.xs="100"
						>
							<textarea
								matInput
								placeholder="{{ this.messageReply }}  "
								required
								[formControl]="replyForm"
								maxlength="200"
								#input
							>
							</textarea>
							<mat-hint align="end">{{ input.value.length || 0 }}/200</mat-hint>
						</mat-form-field>
					</div>
					<div fxLayout="row" fxFill>
						<div
							fxLayout="row"
							fxLayoutAlign="end center"
							fxFlex="90"
							fxLayoutGap="15"
							fxFlex.xs="100"
						>
							<button
								mat-stroked-button
								(click)="onCancelClick(i)"
								color="accent"
								i18n="@@button_cancel"
								id="button_cancel"
							>
								Cancel
							</button>

							<button
								mat-raised-button
								[disabled]="replyForm.invalid"
								color="accent"
								(click)="postReply(input.value, donor.id, i)"
								i18n="@@button_send"
							>
								Send
							</button>
						</div>
					</div>
				</div>

				<!--Amount-->
				<!--Thank you donor-->
				<!-- <div
					fxLayout="column"
					fxLayout.xs="row"
					fxFlex="10%"
					fxLayoutAlign="start center"
				>
					<a
						i18n
						color="accent"
						mat-button
						*ngIf="isLoggedInUserAdmin && !donor.reply_message"
						(click)="replyMessage(i)"
						mat-button
						*ngIf="
							(isLoggedInUserAdmin && donor?.reply_message.length <= 1) ||
							(isLoggedInUserAdmin && !donor?.reply_message)
						"
					>
						Reply
					</a>
				</div> -->
			</div>
			<div
				*ngIf="!this.loadDataCheck"
				fxLayout="column"
				ngClass="m-t-xl"
				fxLayoutAlign="center center"
			>
				<a class="link-decorate-style cursor-pointer" (click)="showMoreData()"
					><span i18n="@@donor_list_full_viewMore_label">View More</span>
					<mat-icon *ngIf="isLoading" class="m-l-xs">
						<mat-spinner color="accent" diameter="16"> </mat-spinner> </mat-icon
				></a>
			</div>
		</mat-tab>
		<mat-tab label="{{ label_donorList_tab2 }}">
			<!--SINGLE DONOR ROW-->
			<div
				fxLayout="column"
				fxLayoutAlign="start start"
				fxLayoutGap.xs="7%"
				fxLayoutGap="0px"
				[style.border-bottom]="'1px solid #ddd'"
				[style.last-child]="'0px'"
				*ngFor="let donor of topContributors; let i = index"
			>
				<!--Avatar-->
				<div
					ngClass="m-t-m"
					fxLayout="row"
					fxFill
					fxFlex.xs="20%"
					fxLayoutGap="1%"
					fxLayoutAlign="start center"
				>
					<app-user-icon
						[initialLetters]="getInitial(donor?.name)"
					></app-user-icon>

					<div fxLayout="column" fxFlex="20%" fxLayoutAlign="start start">
						<div id="donationName">
							<strong> {{ donor?.name }} </strong>
						</div>
						<div fxLayout="row" fxFlex="100%" fxLayoutAlign="start start">
							<div>
								{{ donor?.message }}
							</div>
						</div>
						<!--REPLY BUTTON-->
						<div>
							<a
								*ngIf="
									(isLoggedInUserAdmin && donor?.reply_message?.length <= 1) ||
									(isLoggedInUserAdmin && !donor?.reply_message)
								"
								i18n="@@button_reply"
								mat-button
								color="accent"
								class="zero-padding-margin"
								(click)="openDialog(i)"
							>
								Reply
							</a>
						</div>
					</div>

					<div
						fxLayout="column"
						fxFlex="100%"
						fxFlex.xs="80%"
						fxLayoutAlign="end end"
					>
						<span class="mat-option">
							{{
								donor?.amount | currency : donor?.symbol : 'symbol' : '1.0-0'
							}}
						</span>
					</div>
				</div>
				<!--Name and Message-->

				<div
					fxLayout="row"
					fxLayout="center center"
					fxFlex="20%"
					fxFlex.xs="80%"
					ngClass.lg="m-t-l"
					[style.marginTop.px]="this.media.isActive('lg') ? '10' : '0'"
					ngClass.lg="m-b-m"
					ngClass.xs="m-t-l"
					ngClass.xs="m-l-l"
					ngClass=""
					ngClass.sm="m-t-l"
				>
					<div
						ngClass.lt-lg="m-l-xl m-t-m m-b-m"
						ngClass.lg="m-l-xl m-t-m m-b-m"
						ngClass.xs="m-b-l"
						ngClass="m-l-xl m-t-xs m-b-xs"
						fxLayout="row"
						fxLayoutAlign="start center"
						*ngIf="
							donor?.reply_message &&
							donor?.reply_message?.length >= 1 &&
							!replyButton
						"
					>
						<img
							*ngIf="donor?.reply_message?.length > 2"
							width="30"
							height="30"
							loading="lazy"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donor_small/public"
						/>
						<div
							*ngIf="donor?.reply_message && donor?.reply_message?.length > 1"
							fxLayoutAlign="start start"
							class="m-l-xs"
							fxFill
						>
							{{ donor?.reply_message }}
							<img
								*ngIf="isLoggedInUserAdmin"
								fxLayoutAlign="center center"
								height="16px"
								class="m-l-xs"
								src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/editSmall/public"
								(click)="openDialog(i)"
							/>
						</div>
					</div>
				</div>

				<div
					fxFill
					fxLayout="column"
					fxLayoutAlign="start end"
					ngClass="m-b-m"
					*ngIf="
						isLoggedInUserAdmin &&
						i == this.replyIndex &&
						donor?.reply_message?.length <= 1 &&
						showReplyForm &&
						replyButton &&
						donor?.reply_message?.length != undefined
					"
				>
					<div fxLayout="row" fxFill fxLayoutAlign="flex-start">
						<mat-form-field
							class="example-full-width"
							appearance="outline"
							fxFlex="80"
							fxFlexOffset="10"
							fxFlex.xs="100"
						>
							<textarea
								matInput
								placeholder="{{ this.messageReply }}  "
								required
								[formControl]="replyForm"
								maxlength="200"
								#input
							>
							</textarea>
							<mat-hint align="end">{{ input.value.length || 0 }}/200</mat-hint>
						</mat-form-field>
					</div>
					<div fxLayout="row" fxFill>
						<div
							fxLayout="row"
							fxLayoutAlign="end center"
							fxFlex="90"
							fxLayoutGap="15"
							fxFlex.xs="100"
						>
							<button
								mat-stroked-button
								(click)="onCancelClick(i)"
								color="accent"
								i18n="@@button_cancel"
								id="button_cancel"
							>
								Cancel
							</button>

							<button
								mat-raised-button
								[disabled]="replyForm.invalid"
								color="accent"
								(click)="postReply(input.value, donor.id, i)"
								i18n="@@button_send"
							>
								Send
							</button>
						</div>
					</div>
				</div>

				<!--Amount-->
				<!--Thank you donor-->
				<!-- <div
					fxLayout="column"
					fxLayout.xs="row"
					fxFlex="10%"
					fxLayoutAlign="start center"
				>
					<a
						i18n
						color="accent"
						mat-button
						*ngIf="isLoggedInUserAdmin && !donor.reply_message"
						(click)="replyMessage(i)"
						mat-button
						*ngIf="
							(isLoggedInUserAdmin && donor?.reply_message.length <= 1) ||
							(isLoggedInUserAdmin && !donor?.reply_message)
						"
					>
						Reply
					</a>
				</div> -->
			</div>
			<div
				*ngIf="!this.loadDataCheckTop"
				fxLayout="column"
				ngClass="m-t-xl"
				fxLayoutAlign="center center"
			>
				<a class="link-decorate-style cursor-pointer" (click)="showMoreTopContributorData()"
					><span i18n="@@donor_list_full_viewMore_label">View More</span>
					<mat-icon *ngIf="isLoading" class="m-l-xs">
						<mat-spinner color="accent" diameter="16"> </mat-spinner> </mat-icon
				></a>
			</div>
		</mat-tab>
	</mat-tab-group>
</div>
